<template>
    <div class="c-payments">
        <b-card>
            <div slot="header">
                {{Core.Definition.getDefinition('Sommaire des paiements')}}
                <div v-if="options.displayAddNewPayment" class="card-header-actions">
                    <b-button @click="$refs.modalPayment.open = true" class="btn btn-info btn-sm pull-right">{{Core.Definition.getDefinition('Nouveau paiement')}}</b-button>
                </div>
            </div>
            <PaymentsSummary
                    ref="paymentsSummary"
                    v-model="dataPayments"
                    :displayMakePayment="displayMakePayment"
                    :displayCheckPayment="displayCheckPayment"
                    :displayCompletedPayment="displayCompletedPayment"
                    :displayFullCompletedPayment="displayFullCompletedPayment"
                    :displayPaymentStatus="displayPaymentStatus"
                    :fieldRefs="fieldRefs"
                    :calcTotalOnEval="calcTotalOnEval"
                    @onCheckPayment="onCheckPayment"
                    @onTokenizationSuccess="onTokenizationSuccess"
                    @onEval="onEvalPaymentsSummary"></PaymentsSummary>
        </b-card>

        <ModalPayment
                ref="modalPayment"
                v-model="dataPayment"
                :userId="dataUserId"
                :forceTotal="forceTotal"
                @onTokenizationSuccess="onTokenizationSuccess"
                @onPaymentCompleted="onPaymentCompleted"></ModalPayment>

    </div>
</template>

<script>
    import List from './List'
    import Alert from './Alert'
    import InputSelect from "./InputSelect"
    import InputDate from "./InputDate"
    import InputText from "./InputText"
    import InputCurrency from "./InputCurrency"
    import PaymentsSummary from "./PaymentsSummary"
    import ModalPayment from "./ModalPayment"
    export default {
        name: 'Payments',
        components: {
            InputCurrency,
            List,
            InputSelect,
            InputText,
            InputDate,
            Alert,
            ModalPayment,
            PaymentsSummary
        },
        props: {
            options: {
                type: Object,
                default: function() {
                    return {
                        displayAddNewPayment: true
                    }
                }
            },
            value: {
                type: Array,
                default: function () {
                    return []
                }
            },
            form: {
                type: Object,
                default: function () {
                    return {}
                }
            },
            fieldRefs: {
                type: Array,
                default: function () {
                    return []
                }
            },
            forceTotal: {
                type: Boolean,
                default: true
            },
            calcTotalOnEval: {
                type: Boolean,
                default: false
            },
            displayMakePayment: {
                type: Boolean,
                default: true
            },
            displayCheckPayment: {
                type: Boolean,
                default: false
            },
            displayCompletedPayment: {
                type: Boolean,
                default: true
            },
            displayFullCompletedPayment: {
                type: Boolean,
                default: false
            },
            displayPaymentStatus: {
                type: Boolean,
                default: true
            }
        },
        watch: {
            value(val) {
                this.dataPayments = val
            },
            dataPayments: {
                handler(val) {
                    this.$emit('input', val)
                },
                deep: true
            },
        },
        mounted() {
            this.dataPayments = this.value
        },
        data: () => {
            return {
                Core: window.Core,
                dataPayments: [],
                dataPayment: {
                    date: '',
                    method: Core.Value.selectValue(Core.Payment.methodCC, Core.Payment.methodOptions()),
                    status: null,
                    referenceNumber: '',
                    subTotal: 0,
                    total: 0,
                    totalTaxes: 0,
                    token : '',
                    id: ''
                },
                dataTotal: 0,
                dataSubTotal: 0,
                dataUserId: ''
            }
        },
        computed: {
            total: {
                set(total) {
                    this.$refs.paymentsSummary.total = total
                    this.dataTotal = total
                    this.dataPayment.total = this.$refs.paymentsSummary.balance.toString()
                },
                get() {
                    return this.dataTotal
                }
            },
            subTotal: {
                set(subTotal) {
                    this.$refs.paymentsSummary.subTotal = subTotal
                    this.dataSubTotal = subTotal
                },
                get() {
                    return this.dataSubTotal
                }
            },
            instanceId: {
                set(instanceId) {
                    this.dataInstanceId = instanceId
                },
                get() {
                    return this.dataInstanceId
                }
            },
            userId: {
                get() {
                    return this.dataUserId
                },
                set(val) {
                    this.dataUserId = val
                }
            }
        },
        methods: {
            getPayments() {
                return this.$refs.paymentsSummary.dataPayments
            },
            clearPayments() {
                this.$refs.paymentsSummary.dataPayments = []
            },
            addPayment(date, status, method, subTotal, total, referenceNumber, id) {
                this.$refs.paymentsSummary.addPayment(date, status, method, subTotal, referenceNumber, id)
            },
            dateHasPayment(date) {
                for(let payment in this.dataPayments) {
                    payment = this.dataPayments[payment]
                    if (payment.date == date) {
                        return true
                    }
                }
                return false
            },
            onCheckPayment(payments, fieldRefs) {
                this.$emit('onCheckPayment', payments, fieldRefs)
            },
            onEvalPaymentsSummary(completed, balance, payments) {
                this.dataPayment.subTotal = balance.toString()
            },
            onPaymentCompleted(payment) {
                this.$refs.modalPayment.open = false
                this.$refs.paymentsSummary.addPayment(payment.date, payment.status, Core.Value.decode(payment.method, 'select'), payment.subTotal, payment.referenceNumber)
                this.$emit('onPaymentCompleted', payment)
            },
            onTokenizationSuccess(payment){
                this.$refs.modalPayment.open = false
                this.$emit('onTokenizationSuccess',payment)
            }
        }
    }
</script>
